<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="config?.Value">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationformfile.formfile' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ 'plugins.installationformfile.' + config.Value | translate }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="config?.Instruction">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationformfile.instruction' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span style="display: block" class="ir-ph1">{{ config?.Instruction }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="config?.Value">
    <td class="th-plugin-line--subheader plugin-table-cell"></td>
    <td class="plugin-table-cell th-plugin-line--value">
      <button type="button" class="ir-btn th-btn-modal ir-btn--title ir-txt--right" (click)="download()">
        <span>{{ 'plugins.installationformfile.download' | translate }}</span>
      </button>
    </td>
  </tr>
</table>
